var _path, _path2, _g, _g2, _g3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSchedule(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    enableBackground: "new 0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#CFD8DC",
    d: "M5,38V14h38v24c0,2.2-1.8,4-4,4H9C6.8,42,5,40.2,5,38z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#F44336",
    d: "M43,10v6H5v-6c0-2.2,1.8-4,4-4h30C41.2,6,43,7.8,43,10z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#B71C1C"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 33,
    cy: 10,
    r: 3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 10,
    r: 3
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fill: "#B0BEC5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33,3c-1.1,0-2,0.9-2,2v5c0,1.1,0.9,2,2,2s2-0.9,2-2V5C35,3.9,34.1,3,33,3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15,3c-1.1,0-2,0.9-2,2v5c0,1.1,0.9,2,2,2s2-0.9,2-2V5C17,3.9,16.1,3,15,3z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    fill: "#90A4AE"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 20,
    width: 4,
    height: 4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 19,
    y: 20,
    width: 4,
    height: 4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 25,
    y: 20,
    width: 4,
    height: 4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 31,
    y: 20,
    width: 4,
    height: 4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 26,
    width: 4,
    height: 4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 19,
    y: 26,
    width: 4,
    height: 4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 25,
    y: 26,
    width: 4,
    height: 4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 31,
    y: 26,
    width: 4,
    height: 4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 32,
    width: 4,
    height: 4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 19,
    y: 32,
    width: 4,
    height: 4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 25,
    y: 32,
    width: 4,
    height: 4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 31,
    y: 32,
    width: 4,
    height: 4
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSchedule);
export default __webpack_public_path__ + "static/media/schedule.951e3e8ce287162c4f47a2e264d4faca.svg";
export { ForwardRef as ReactComponent };